'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeRatioMap = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var sizeRatioMap = exports.sizeRatioMap = {
  small: 16 / 9,
  medium: 4 / 3,
  large: 6 / 5,
  xLarge: 1,
  answer: 4 / 3
};

var resizeHoc = function resizeHoc() {
  var ratioMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sizeRatioMap;
  return function (WrappedComponent) {
    var Resize = function (_React$Component) {
      _inherits(Resize, _React$Component);

      function Resize(props) {
        _classCallCheck(this, Resize);

        var _this = _possibleConstructorReturn(this, (Resize.__proto__ || Object.getPrototypeOf(Resize)).call(this, props));

        _this.updateElementSize = function () {
          if (_this.props.fixedWidth || !_this.element.current) return;

          var width = _this.element.current.getBoundingClientRect().width;

          var height = _this.calculateHeight(width);

          var newState = {};

          if (!isNaN(height) && height !== _this.state.height) {
            newState.height = height;
          }

          if (!isNaN(width) && width !== _this.state.width) {
            newState.width = width;
          }

          if (Object.keys(newState).length > 0) {
            _this.setState(_extends({}, _this.state, newState));
          }
        };

        _this.calculateHeight = function () {
          var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.width;
          return width / _this.ratio;
        };

        _this.sizeRatioMap = ratioMap;
        _this.state = {
          width: props.width || 0,
          height: props.height || 0,
          src: props.src
        };

        if (props.fixedWidth) {
          _this.state.width = props.fixedWidth;
          _this.state.height = _this.calculateHeight(props.fixedWidth);
        }

        _this.element = _react2['default'].createRef();
        return _this;
      }

      _createClass(Resize, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          // if (!this.state.height || !this.state.width) {
          this.updateElementSize(); // }

          window.addEventListener('resize', this.updateElementSize);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('resize', this.updateElementSize);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (prevProps.size !== this.props.size || prevProps.src !== this.props.src) {
            this.updateElementSize();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state,
              height = _state.height,
              width = _state.width;
          var style = {
            height: height
          };
          return _react2['default'].createElement('div', {
            ref: this.element,
            style: style
          }, _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
            height: height,
            width: width,
            ratio: this.ratio
          })));
        }
      }, {
        key: 'ratio',
        get: function get() {
          var size = this.props.size;
          return this.sizeRatioMap[size];
        }
      }]);

      return Resize;
    }(_react2['default'].Component);

    Resize.displayName = 'Resized(' + WrappedComponent.displayName + ')';
    Resize.propTypes = _extends({}, WrappedComponent.propTypes, {
      fixedWidth: _propTypes2['default'].number
    });
    Resize.defaultProps = _extends({}, WrappedComponent.defaultProps);
    return (0, _hoistNonReactStatics2['default'])(Resize, WrappedComponent);
  };
};

exports['default'] = resizeHoc;